"use strict";

var makeLogout = function makeLogout(_ref) {
  var getClient = _ref.getClient,
    removeTokenFromCookie = _ref.removeTokenFromCookie;
  return function (_ref2) {
    var returnTo = _ref2.returnTo;
    return getClient().then(function (client) {
      // remove token
      removeTokenFromCookie();
      return client.logoutAsync({
        returnTo: returnTo
      });
    });
  };
};
module.exports = {
  makeLogout: makeLogout
};